import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";

import Logout from "../../ui/Logout";
import PaymentBell from "../ui/PaymentBell";
import SupportBell from "../ui/SupportBell";

const Header = () => {
  const [fullName, setFullName] = useState("");

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [showElement, setShowElement] = useState(false);
  const [logoutDisplay, setLogoutDisplay] = useState(false);

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
      setFullName(user?.token.lastName + " " + user?.token.firstName);
    }
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onLogoutHanadler = () => {
    setLogoutDisplay(true);
  };

  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light ">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" role="button">
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>

        {showElement[0] !== "notConnected" && (
          <ul className="navbar-nav ml-auto">
            {Array.isArray(showElement) && showElement.includes("SUPER_ADMIN") && <PaymentBell />}
            {Array.isArray(showElement) &&
              (showElement.includes("SUPER_ADMIN") || showElement.includes("ADMIN")) && <SupportBell />}
            <li className="nav-item dropdown"></li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-widget="fullscreen"
                href="#"
                role="button"
              >
                <i className="fas fa-expand-arrows-alt" />
              </a>
            </li>

            <li className="nav-item">
              <button
                type="button"
                className="btn btn-dark"
                data-toggle="modal"
                data-target="#modal-secondary"
                onClick={onLogoutHanadler}
              >
                {fullName}
              </button>
            </li>
          </ul>
        )}
      </nav>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          L’adresse e-mail et le mot de passe que vous avez saisi(e) n’est pas
          associé(e) à un compte.
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleInfoClose} severity="info">
          votre session est expiré
        </Alert>
      </Snackbar>
      {logoutDisplay && <Logout setLogoutDisplay={setLogoutDisplay}></Logout>}
    </div>
  );
};
export default Header;
